export const FAQ_GROUPS = [
  {
    slug: "plans-boxes",
    name: "Plans & Boxes",
    items: [
      {
        q: "What type of plans do you offer?",
        a: "We offer two ways to shop: seven Signature boxes (Starter, Gluten Free, Performance, Braai, Family Feast, Carnivore Collection, Grill Master's) or Build Your Own Box from our full product range. Every box can be purchased once-off or as a subscription — subscribing saves you 5% on every order and includes a free pack of Wagyu Beef Burgers with every delivery.",
      },
      {
        q: "What's the difference between the seven Signature boxes?",
        a: "Starter Box ($99, 5kg) is our entry point for first-timers. Gluten Free Box ($149, 8kg) is 100% GF. Performance Box ($199, 8.5kg) is lean protein for athletes with biltong & jerky. Braai Box ($199, 8.6kg — founding price, standard $219) is South African style — boerewors, biltong, droewors. Family Feast Box ($269, 13.7kg) is our best-seller for weekly meal planning. Carnivore Collection ($319, 8kg) is 100% beef, nose to tail. Grill Master's Box ($329, 9.6kg) is loaded with tomahawks, scotch fillet and Wagyu burgers.",
      },
      {
        q: "Can I build my own box?",
        a: "Yes. Head to Build Your Own Box, pick a category, add whatever cuts you like, and check out. Retail pricing applies. Minimum order is $99. Free delivery on every order. You can also subscribe to your custom box for 5% off + free Wagyu burgers with every delivery.",
      },
      {
        q: "What is the minimum order?",
        a: "$99. Free delivery is included on every order.",
      },
      {
        q: "Do you offer a small household or single-person box?",
        a: "The Starter Box is our smallest Signature option at 5kg / $99 — designed for first-timers and small households. Alternatively, build your own box down to the $99 minimum.",
      },
      {
        q: "Do you include pork?",
        a: "No. THE BUTCHER BOX does not offer pork — not in any Signature box, category, or product line.",
      },
    ],
  },
  {
    slug: "whats-inside",
    name: "What's Inside",
    items: [
      {
        q: "What types of meat will I get?",
        a: "Premium Australian beef (steaks, roasts, mince, ribs, offal), free-range chicken, pasture-raised lamb, gourmet Wagyu and beef burgers, gluten-free sausages, smoked smallgoods, gourmet jerky, biltong, droewors and frozen pies. Every cut is vacuum sealed and clearly labelled.",
      },
      {
        q: "Are all cuts vacuum packed?",
        a: "Yes. Every cut is individually vacuum sealed at the butcher for maximum freshness and to keep your freezer organised. You'll know exactly what's inside every pack.",
      },
      {
        q: "What are the free Wagyu Beef Burgers with subscription?",
        a: "Every subscription delivery — regardless of the box you order or how you customise it — includes a complimentary pack of our gourmet Wagyu Beef Burgers (approximately 200g each). It's our way of saying thank you for subscribing.",
      },
      {
        q: "Are your sausages gluten free?",
        a: "Our Gluten Free Sausages range (chicken cheese corn, peri peri, BBQ, boerewors, Italian, etc.) is 100% gluten free. Other smallgoods, jerky, and pies may contain gluten — check the product page for details.",
      },
      {
        q: "Are individual cut weights exact?",
        a: "Individual cuts may vary ±5–10% from the listed weight — meat is a natural product, and we hand-cut every portion. Total box weight is always at or above the listed weight for that box.",
      },
      {
        q: "Do you sell Wagyu?",
        a: "Yes. Gourmet Wagyu Beef Burgers, Wagyu Jalapeno Burgers and Wagyu Biltong are all part of our range. Wagyu burgers are also included free with every subscription delivery.",
      },
    ],
  },
  {
    slug: "sourcing-standards",
    name: "Sourcing & Standards",
    items: [
      {
        q: "Is your meat halal certified?",
        a: "Yes — everything. Every cut of beef, lamb and chicken we sell is halal certified through accredited Australian halal authorities. There is no separate halal range because the entire range is certified, and every product is traceable to accredited abattoirs.",
      },
      {
        q: "Where does your meat come from?",
        a: "All of our meat is 100% Australian — sourced from family farms, cooperatives and trusted suppliers across QLD, NSW, VIC and WA. We never source from feedlots or intensive operations. Our lamb comes from pasture-raised flocks; our chicken is free-range; our beef is grass-fed or grain-finished on pasture.",
      },
      {
        q: "Is your beef grass-fed or grain-finished?",
        a: "We offer both. Our 100% grass-fed beef eats a natural diet of grass and forage its entire life — lean, robust flavour and higher in Omega-3s. Our grain-finished beef is raised on pasture and finished on grains at the end of life for additional marbling and tenderness. Every product page clearly labels which category the cut belongs to.",
      },
      {
        q: "Is your chicken free-range or organic?",
        a: "Our chicken is free-range — the birds have continuous outdoor access, roam freely, and are never caged. Organic chicken is available seasonally when supply allows; it's clearly labelled on the product.",
      },
      {
        q: "Is your lamb pasture-raised?",
        a: "Yes. All lamb is pasture-raised on Australian farms — never confined, always grazing on native pasture.",
      },
      {
        q: "Are your animals given hormones or antibiotics?",
        a: "No added hormones, ever. Antibiotics are only ever used when medically necessary to treat an animal — never routinely, never as growth promoters. Australia has among the strictest antibiotic regulations in the world.",
      },
      {
        q: "Are your animals humanely raised?",
        a: "Yes. We only work with farms that meet Australian animal welfare standards and can demonstrate humane raising and processing practices. Facilities are routinely inspected by the relevant Australian authorities and independent auditors.",
      },
      {
        q: "Is the meat MSA graded?",
        a: "Our premium beef cuts are MSA (Meat Standards Australia) graded, which independently rates each carcass for tenderness, juiciness and flavour. Look for MSA on the product page.",
      },
    ],
  },
  {
    slug: "delivery",
    name: "Delivery",
    items: [
      {
        q: "Where do you deliver?",
        a: "We currently deliver across Perth metro (postcodes 6000–6199). Enter your postcode on the home page to check instantly. Not in our zone yet? Join the waitlist and we'll email you as soon as we expand to your area.",
      },
      {
        q: "How much is delivery?",
        a: "Free delivery on every order across Perth metro. Subscribers receive priority dispatch — your box is packed and shipped first.",
      },
      {
        q: "When is the order cut-off?",
        a: "Order by Thursday 11pm (Perth time). We pack fresh on Friday and deliver Saturday across Perth metro. Orders placed after 11pm Thursday go into the following week's Friday pack for the next Saturday run.",
      },
      {
        q: "Do you deliver on weekends?",
        a: "Deliveries run Saturday across Perth metro. Sundays are excluded.",
      },
      {
        q: "What if I'm not home when it arrives?",
        a: "You don't have to be home. Every box ships in an insulated liner with food-grade dry ice / cold packs, keeping contents refrigerator-cold for 6–8 hours after delivery. If you're going to be out, leave a delivery note at checkout with a safe drop location.",
      },
      {
        q: "How is my meat packaged?",
        a: "Each cut is vacuum sealed at the butcher, packed into an insulated recyclable liner with dry ice or gel packs, then boxed in our sturdy branded outer carton. The packaging keeps your meat at refrigerator temperature or below during transit.",
      },
    ],
  },
  {
    slug: "subscription-billing",
    name: "Subscription & Billing",
    items: [
      {
        q: "What are the subscription benefits?",
        a: "Subscribers get 5% off every order, a free pack of Wagyu Beef Burgers with every delivery, priority dispatch, the ability to pause/skip/cancel anytime, and control over your delivery frequency. No lock-in contract, ever.",
      },
      {
        q: "What are the delivery frequency options?",
        a: "Every 2 weeks or every 4 weeks. Choose the rhythm that fits your household — most families find every 4 weeks is the right rhythm to refill the freezer.",
      },
      {
        q: "Can I pause or skip a delivery?",
        a: "Yes — instantly, from your account dashboard. Pause your subscription for as long as you like, or skip a single upcoming delivery. Resume whenever you're ready.",
      },
      {
        q: "Can I cancel my subscription anytime?",
        a: "Absolutely. No fees, no lock-in, no phone calls. Cancel with one click from your account. If you cancel after an order has already processed, you'll still receive that delivery.",
      },
      {
        q: "How do I change my delivery frequency?",
        a: "Log in, go to Subscriptions, and switch between every 2 weeks and every 4 weeks. Changes apply from your next scheduled billing date.",
      },
      {
        q: "When am I billed?",
        a: "Your subscription is billed at the start of each cycle (every 2 or 4 weeks) — you'll get an email confirmation. Your box then ships in time for the next Saturday delivery.",
      },
      {
        q: "Do I get free Wagyu Beef Burgers on every single order?",
        a: "Yes — every subscription delivery includes a complimentary pack of Wagyu Beef Burgers. For the whole life of your subscription.",
      },
      {
        q: "Do I need to have an account to order?",
        a: "You can check out as a guest for once-off orders. To subscribe and manage deliveries, orders and preferences, you'll need an account (email/password — free and takes 10 seconds).",
      },
    ],
  },
  {
    slug: "freshness-storage",
    name: "Freshness & Storage",
    items: [
      {
        q: "How is my meat kept fresh in transit?",
        a: "Every box ships with the optimal amount of dry ice / gel packs (calculated for your postcode and season) inside an insulated liner. Meat arrives refrigerator-cold or partly frozen — safe to refrigerate or freeze immediately.",
      },
      {
        q: "How long can I keep the meat?",
        a: "In the fridge: use within 3–5 days for beef and lamb, 1–2 days for chicken and mince. In the freezer: up to 6 months for whole cuts, 3 months for mince and burgers. Vacuum sealed cuts last longer than store-bought.",
      },
      {
        q: "Can I freeze the meat when it arrives?",
        a: "Yes — freeze immediately for best quality. Because every cut is vacuum sealed, you can freeze straight from the box without repackaging.",
      },
      {
        q: "What if I'm unhappy with an order?",
        a: "We back every order with our Satisfaction Guarantee — replacement or credit, your choice. If anything in your box isn't right (quality, packaging, freshness), contact our support team within 48 hours and we'll make it right, no questions asked.",
      },
    ],
  },
  {
    slug: "wholesale-export",
    name: "Wholesale & Export",
    items: [
      {
        q: "Do you supply restaurants and cafes?",
        a: "Yes. We supply restaurants, cafes, hotels, caterers, schools, mining camps and private label buyers across Perth and WA. Apply via our Wholesale page and our trade team will contact you within one business day.",
      },
      {
        q: "Do you export?",
        a: "Yes — we export premium Australian meat to Malaysia, Singapore, UAE and other markets on request. Bulk cartons, private label and full export documentation are available.",
      },
    ],
  },
];
